var C;!function(C){C.BASIC="BASIC",C.COMPACT="COMPACT",C.PRO="PRO"}(C||(C={}));var a=C;export{a as default};
